import { createBudgetsClient, readBudgetIdentifier } from '@liquid-spirit/api/domains/budgets';
import apiClient from './apiClient';

const budgets = createBudgetsClient(apiClient);
const transportOptions = options => {
  if (options.params?.communityId != null) readBudgetIdentifier(options.params.communityId);
  return options;
};

export async function getCurrentBudget({ token, ...options }) {
  return budgets.getCurrent(transportOptions({ ...options, token }));
}

export async function listBudgets({ token, ...options }) {
  return budgets.list(transportOptions({ ...options, token }));
}

export async function createBudget({ token, payload, ...options }) {
  return budgets.create(payload, transportOptions({ ...options, token }));
}

export async function updateBudget({ token, budgetId, payload, ...options }) {
  return budgets.update(budgetId, payload, transportOptions({ ...options, token }));
}

export async function approveBudget({ token, budgetId, payload = {}, ...options }) {
  return budgets.approve(budgetId, payload, transportOptions({ ...options, token }));
}

export async function createBudgetAllocation({ token, budgetId, payload, ...options }) {
  return budgets.createAllocation(budgetId, payload, transportOptions({ ...options, token }));
}

export async function requestBudgetAllocation({ token, budgetId, payload, ...options }) {
  return budgets.requestAllocation(budgetId, payload, transportOptions({ ...options, token }));
}

export async function updateBudgetAllocation({ token, allocationId, payload, ...options }) {
  return budgets.updateAllocation(allocationId, payload, transportOptions({ ...options, token }));
}

export async function deleteBudgetAllocation({ token, allocationId, ...options }) {
  return budgets.deleteAllocation(allocationId, transportOptions({ ...options, token }));
}

export async function approveBudgetAllocationRequest({ token, allocationId, payload = {}, ...options }) {
  return budgets.approveAllocationRequest(allocationId, payload, transportOptions({ ...options, token }));
}

export async function declineBudgetAllocationRequest({ token, allocationId, payload = {}, ...options }) {
  return budgets.declineAllocationRequest(allocationId, payload, transportOptions({ ...options, token }));
}
